import { IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { Trash } from '@phosphor-icons/react';
import { useCallback } from 'react';
import { useEdges, useReactFlow } from 'reactflow';
import styled from 'styled-components';
import useFlowsStore from '../../store/storeFlows';

const StyledPaper = styled(Paper)`
  display: flex;
  gap: 12px;
  padding: 8px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  align-items: center;
`;

const MultiEdgeSelectIndicator = () => {
  const edges = useEdges();
  const { setEdges } = useReactFlow();
  const onEdgeDelete = useFlowsStore(state => state.onEdgeDelete);

  const selectedEdges = edges.filter(e => e.selected);
  const selectedCount = selectedEdges.length;

  const handleConfirm = useCallback(() => {
    if (selectedCount === 0) return;
    const idsToRemove = new Set(selectedEdges.map(e => e.id));
    setEdges(currentEdges => currentEdges.filter(e => !idsToRemove.has(e.id)));
    onEdgeDelete(selectedEdges, selectedEdges[0]?.id);
  }, [selectedCount, selectedEdges, setEdges, onEdgeDelete]);

  if (selectedCount <= 1) {
    return null;
  }

  return (
    <StyledPaper>
      <Typography variant="caption" color="text.secondary">
        {selectedCount} edge{selectedCount > 1 ? 's' : ''} selected
      </Typography>
      <Tooltip title="Delete selected edges" placement="bottom" arrow>
        <IconButton
          color="error"
          onClick={handleConfirm}
          sx={{ fontSize: '0.75rem' }}
        >
          <Trash />
        </IconButton>
      </Tooltip>
    </StyledPaper>
  );
};

export default MultiEdgeSelectIndicator;
